<mat-list-item>
  <mat-icon fontIcon="fa-house-damage" fontSet="far" style="align-content: end" matListItemAvatar></mat-icon>
  @if (hiddenFromOperative) {
    <mat-icon fontIcon="fa-eye-slash" fontSet="far" style="align-content: end" matListItemAvatar [matTooltip]="'Shown to operative as:\n' + cautionCode.Attc_AlternateText" matTooltipClass="multiline-tooltip">
    </mat-icon>
  }
  <div matListItemTitle><span>{{ topText }}</span></div>
  <div matListItemLine><i>Property Caution</i></div>
</mat-list-item>
